import { render, staticRenderFns } from "./oauth.vue?vue&type=template&id=2b08c0ce&scoped=true&"
import script from "./oauth.vue?vue&type=script&lang=js&"
export * from "./oauth.vue?vue&type=script&lang=js&"
import style0 from "./oauth.vue?vue&type=style&index=0&id=2b08c0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08c0ce",
  null
  
)

export default component.exports